export { default as translations } from './translations.json';

export const MAX_PORTFOLIO_ITEMS = 20;

/**
 * Get portfolio from user.
 * @param {Object|null} user
 * @returns {Object[]}
 */
export const getPortfolio = (user) => {
  const portfolio = user?.attributes?.profile?.publicData?.portfolio || [];
  return [...portfolio].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
};

export const hasPortfolio = (user) => getPortfolio(user).length > 0;

/**
 * Validate portfolio item.
 * @param {Object} item
 * @returns {string|null}
 */
export const validatePortfolioItem = (item) => {
  if (!item?.title?.trim()) return 'Title required';
  if (item.title.length > 100) return 'Title max 100 characters';
  if (item.description && item.description.length > 500) return 'Description max 500 characters';
  return null;
};
